/**
 * What the task type editor's "Linked workflows" section shows. Listing
 * them also needs workflow read, so a person without it sees why instead of
 * an empty list.
 */
export type TaskTypeFeedsView =
  'no-access' | 'loading' | 'error' | 'empty' | 'list';

export function taskTypeFeedsView({
  canReadWorkflows,
  isLoading,
  isError,
  feedCount,
}: {
  canReadWorkflows: boolean;
  isLoading: boolean;
  isError: boolean;
  feedCount: number;
}): TaskTypeFeedsView {
  if (!canReadWorkflows) return 'no-access';
  if (isLoading) return 'loading';
  if (isError) return 'error';
  return feedCount > 0 ? 'list' : 'empty';
}
